<template>
  <div class="candies">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <img class="icon" src="./images/icon.png" alt="" />
      <span class="balance">{{ balance }}</span>
      <div class="lucky-draw-box">
        <LuckyGrid
          ref="myLucky"
          :width="width"
          :height="height"
          :prizes="prizes"
          :rows="rows"
          :cols="cols"
          :blocks="blocks"
          :buttons="buttons"
          :speed="100"
          :active-style="activeStyle"
          @start="clickDrawButton"
          @end="endLuck"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CandiesDraw',
  data() {
    return {
      width: '614px',
      height: '614px',
      rows: 3,
      cols: 3,
      blocks: [
        {
          padding: '44px',
          // background: '#869cfa',
          imgs: [
            {
              src: require('@/activities/candies/images/draw-bg.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ],
      prizes: [
        {
          x: 0,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies/images/1.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active1.png')
            }
          ]
        },
        {
          x: 1,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies/images/2.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active2.png')
            }
          ]
        },
        {
          x: 2,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies/images/3.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active3.png')
            }
          ]
        },
        {
          x: 2,
          y: 1,
          imgs: [
            {
              src: require('@/activities/candies/images/4.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active4.png')
            }
          ]
        },
        {
          x: 2,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies/images/5.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active5.png')
            }
          ]
        },
        {
          x: 1,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies/images/6.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active6.png')
            }
          ]
        },
        {
          x: 0,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies/images/7.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active7.png')
            }
          ]
        },
        {
          x: 0,
          y: 1,
          imgs: [
            {
              src: require('@/activities/candies/images/8.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies/images/active8.png')
            }
          ]
        }
      ],
      activeStyle: {
        background: 'transparent'
      },
      isShowRulesDialog: false,
      drawResult: '', //抽獎結果
      candyCostNumber: 500, //抽一次獎話費糖果數量
      balance: 0, //糖果餘額
      drawLoading: false,
      activityData: {}
    };
  },
  computed: {
    buttons() {
      return [
        {
          x: 1,
          y: 1,
          imgs: [
            {
              src: this.drawLoading
                ? require('@/activities/candies/images/active-button.png')
                : require('@/activities/candies/images/button.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ];
    }
  },
  methods: {
    // 活動結束提醒
    showFinishedDialog() {
      if (true) {
        this.$confirm({
          content:
            '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          this.$router.push({ path: '/' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        // this.balance = 500;
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo',
          {
            dictType: 'lotteryConf'
          }
        );
        this.balance = data.crystalBalance || 0;
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },
    // 點擊抽獎按鈕
    clickDrawButton() {
      if (!this.drawLoading) {
        this.drawLoading = true;
        this.$confirm({
          content: '是否花費500個糖果進行抽獎？',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        })
          .then(() => {
            if (this.balance >= this.candyCostNumber) {
              this.getDrawInfo();
            } else {
              this.$confirm({
                content:
                  '抱歉，您當前所擁有的糖果餘額數量不足，無法參與本次抽獎',
                title: '提示',
                showCancelButton: false,
                confirmButtonText: '確定',
                closeOnClickOverlay: true
              });
              this.drawLoading = false;
            }
          })
          .catch(() => {
            this.drawLoading = false;
          });
      }
    },
    // 獲取抽獎結果
    async getDrawInfo() {
      try {
        const { data } = await this.$http.get('/activity/lottery', {
          dictType: 'lotteryConf',
          count: 1
        });
        if (data) {
          this.drawResult = data;
          this.startLuck();
        }
      } catch (error) {
        this.drawLoading = false;
      }
    },

    // 開始抽獎
    startLuck() {
      switch (this.drawResult) {
        case 'P08':
          this.luckIndex = 0; // 謝謝參與
          break;
        case 'P03':
          this.luckIndex = 1; // 66幣
          break;
        case 'P01':
          this.luckIndex = 2; // 288鑽石
          break;
        case 'P07':
          this.luckIndex = 3; // 滿減40券
          break;
        case 'P05':
          this.luckIndex = 4; // 666幣
          break;
        case 'P04':
          this.luckIndex = 5; // 166幣
          break;
        case 'P02':
          this.luckIndex = 6; // 888鑽石
          break;
        case 'P06':
          this.luckIndex = 7; // 滿減20券
          break;
        default:
          break;
      }
      this.startCallback();
    },
    // 點選抽獎按鈕會觸發start回調
    startCallback() {
      console.log('startCallback');
      // 調用抽獎組件的play方法開始遊戲
      this.$refs.myLucky.play();
      // 調用接口異步抽獎
      setTimeout(() => {
        // 調用stop停止旋轉並傳遞中獎索引
        this.$refs.myLucky.stop(this.luckIndex);
      }, 2000);
    },
    // 抽獎結束
    endLuck() {
      this.balance -= this.candyCostNumber;
      this.drawLoading = false;
      if (this.luckIndex === 0) {
        this.$confirm({
          content: '本次你沒有抽到獎品，謝謝參與',
          title: '很遺憾',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      } else {
        let drawName = '';
        switch (this.drawResult) {
          case 'P08':
            drawName = '謝謝參與';
            break;
          case 'P03':
            drawName = '66幣';
            break;
          case 'P01':
            drawName = '288鑽石';
            break;
          case 'P07':
            drawName = '滿減40券';
            break;
          case 'P05':
            drawName = '666幣';
            break;
          case 'P04':
            drawName = '166幣';
            break;
          case 'P02':
            drawName = '888鑽石';
            break;
          case 'P06':
            drawName = '滿減20券';
            break;
          default:
            break;
        }
        this.$confirm({
          content: `幸運地抽中了：${drawName}`,
          title: '恭喜你！',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.candies {
  width: 100%;
  // height: 100vh;
  background-color: #fef2f5;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    // background-color: #fef2f5;
    // background-color: #caf5ff;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
    .icon {
      position: absolute;
      top: 1422.92px;
      right: 189.81px;
      color: #441bb8;
      z-index: 2;
      width: 327.24px;
      height: auto;
    }
    .balance {
      position: absolute;
      top: 690.8px;
      right: 267.47px;
      font-size: 50px;
      line-height: 1;
      color: #441bb8;
      font-weight: bold;
    }
    .lucky-draw-box {
      text-align: left;
      display: block;
      width: 608px;
      position: absolute;
      top: 814.92px;
      right: 187px;
    }
  }
}
</style>
<style lang="scss">
.dialog-center {
  .van-dialog__message,
  .van-dialog__header {
    text-align: center;
  }
}
</style>